import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_TEXT } from '../../../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SMALL_TEXT } from '../../../styles/typography/typography';
export var StyledRefreshIndicator = styled('div')(function () {
  return {
    '&.EmbersTable-RefreshIndicator-root': {
      position: 'relative',
      paddingLeft: 20,
      '.icon-reload': {
        position: 'absolute',
        left: 0,
        top: 5,
        fontSize: 16,
        color: PROMETHEAN_TEXT
      },
      '.EmbersTable-RefreshIndicator-lastUpdated': _objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT)
    }
  };
});